import { IActionFn, IPageData } from '@/store/types';
import { IModuleState } from './types';
import { $file, $http } from '@/axios';
import { downloadFile } from '@/utils/helper';
import store from '@/store';

// 查询型材产品列表
export const querySectionProducts: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setSectionProducts', { ...state.list, loading: true });
    const res: IPageData = await $http.post('/v1/data/asset/sectionproduct/pagelist', payload);
    commit('setSectionProducts', { data: res.list, pageNum: res.pageNum, pageSize: res.pageSize, total: res.total });
  } catch (e) {
    commit('setSectionProducts', { data: [], pageNum: 0, pageSize: 0, total: 0 });
  }
};

// 查询型材产品详情
export const querySectionProductDetail: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setSectionProductDetail', { data: null, loading: true });
    const res = await $http.get(`/v1/asset/sectionproduct/${payload}/detail`);
    commit('setSectionProductDetail', { data: res, loading: false });
  } catch (e) {
    commit('setSectionProductDetail', { data: null, loading: false });
  }
};

// 添加型材产品
export const addSectionProduct: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setLoading', true);
    await $http.post('/v1/asset/sectionproduct/add', payload);
    commit('setLoading', false);
    store.commit('common/setToast', { visible: true, text: '新增成功' });
  } catch (e) {
    commit('setLoading', false);
  }
};

// 编辑型材产品
export const editSectionProduct: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setLoading', true);
    await $http.post('/v1/asset/sectionproduct/updatecontent', payload);
    // await $http.post('/v1/asset/sectionproduct/modify', payload);
    store.commit('common/setToast', { visible: true, text: '编辑成功' });
  } finally {
    commit('setLoading', false);
  }
};

// 删除型材产品
export const deleteSectionProduct: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    await $http.post('/v1/asset/sectionproduct/delete', payload);
  } finally {
    commit('setConfirm', { visible: false });
  }
};

// 上下架型材产品
export const shelfSectionProduct: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    await $http.post('/v1/asset/sectionproduct/shelf', payload);
    commit('setConfirm', { visible: false, loading: false });
  } catch (e) {
    commit('setConfirm', { visible: false, loading: false });
  }
};

// 更新型材产品缩略图
export const updateSectionProductThumb: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setSectionProductThumb', { ...state.thumb, loading: true });
    const res = await $http.post('/v1/asset/sectionproduct/modifyimg', payload);
    commit('setSectionProductThumb', { data: res, loading: false });
  } catch (e) {
    commit('setSectionProductThumb', { data: null, loading: false });
  }
};

// 刷新型材产品索引
export const refreshSectionProductIndex: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    await $http.post('/v1/asset/sectionproduct/refresh', payload);
    store.commit('common/setToast', { visible: true, text: '索引刷新成功' });
  } finally {
    commit('setConfirm', { visible: false });
  }
};

// 导出型材产品关键字
export const exportSectionProductKeyword: IActionFn<IModuleState> = async ({ rootState }, payload) => {
  const commitType = 'materials/common/setDialogExport'; // 对应的文件路径为: /src/store/materials/common/mutations
  const commitState = rootState.materials.common.dialogExport;

  try {
    store.commit(commitType, { ...commitState, loading: true });
    const res: { blob: Blob; filename: string } = await $file.post('/v1/asset/item/exportkeywords', payload);
    downloadFile(res.blob, '物品关键字列表');
  } finally {
    store.commit(commitType, { visible: false });
  }
};

// 导入型材产品关键字
export const importSectionProductKeyword: IActionFn<IModuleState> = async ({ rootState }, payload) => {
  const commitType = 'materials/common/setDialogImport'; // 对应的文件路径为: /src/store/materials/common/mutations
  const commitState = rootState.materials.common.dialogImport;

  try {
    const { type, file } = payload;
    const formData = new FormData();
    formData.append('type', type);
    formData.append('file', file);
    formData.append('fileName', file.name);
    store.commit(commitType, { ...commitState, loading: true });
    await $http.post('/v1/asset/item/inputkeywords', formData);
    store.commit('common/setToast', { visible: true, text: '关键字导入成功' });
  } finally {
    store.commit(commitType, { visible: false });
  }
};

// 删除型材产品过滤项配置
export const deleteSectionProductFilter: IActionFn<IModuleState> = async (_, payload) => {
  try {
    await $http.post('/v1/asset/sectionproduct/filter/delete', payload);
    return true;
  } catch (e) {
    return false;
  }
};

// 保存型材产品过滤项配置
export const saveSectionProductFilter: IActionFn<IModuleState> = async (_, payload) => {
  try {
    await $http.post('/v1/asset/sectionproduct/filter/modify', payload);
    store.commit('common/setToast', { visible: true, text: '保存成功' });
  } catch (e) {
    store.commit('common/setToast', { visible: true, text: '保存失败' });
    return false; // 相当于 resolve(false)
  }
};
